import { ISelectableOption } from "../../../../../types";
import {
  Avatar,
  ListItemGraphic,
  ListItemPrimaryText,
  ListItemText,
} from "@cdkglobal/radial";
import { Item, Wrapper } from "../../../../../utils/styled";

type Props = {
  inputValues: ISelectableOption[];
};

export default function ETCAbsenseCodeClassificationReference({
  inputValues,
}: Readonly<Props>): JSX.Element {
  return (
    <Wrapper>
      {inputValues.map((item) => (
        <Item key={String(item.value)} size="large">
          <ListItemGraphic>
            <Avatar variant="text" label={item.label} />
          </ListItemGraphic>

          <ListItemText>
            <ListItemPrimaryText>{item.label}</ListItemPrimaryText>
          </ListItemText>
        </Item>
      ))}
    </Wrapper>
  );
}
